// extracted by mini-css-extract-plugin
export default {"note_item":"NoteItem_note_item__Y7tmH"};